import React from 'react';
import { Stack, Button, TextField, InputAdornment, Tooltip } from '@mui/material';
import { maskCurrencyInput } from '../../../../../utils/currency';

const MODE_FIXO = 'fixo';
const MODE_A_PARTIR_DE = 'a_partir_de';
const MODE_SOB_CONSULTA = 'sob_consulta';

const modeFromValue = (valor) => (valor === null || valor === undefined || valor === '' ? MODE_SOB_CONSULTA : null);

// Seletor de preço com 3 modos (fixo / "a partir de" / sob consulta) +
// campo com máscara de moeda em reais - controla `valor` (null quando
// "sob consulta") e `valorAPartirDe` (bool, só relevante quando valor
// está preenchido).
const ImovelPriceInput = ({ valor, valorAPartirDe, onChange }) => {
    const mode = modeFromValue(valor) || (valorAPartirDe ? MODE_A_PARTIR_DE : MODE_FIXO);
    const display = valor === null || valor === undefined || valor === '' ? '' : Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const setMode = (newMode) => {
        if (newMode === MODE_SOB_CONSULTA) {
            onChange({ valor: null, valorAPartirDe: false });
        } else {
            onChange({ valor: valor || 0, valorAPartirDe: newMode === MODE_A_PARTIR_DE });
        }
    };

    const handleValueChange = (e) => {
        const { numeric } = maskCurrencyInput(e.target.value);
        onChange({ valor: numeric, valorAPartirDe: mode === MODE_A_PARTIR_DE });
    };

    return (
        <Stack spacing={1}>
            <Stack direction="row" spacing={1}>
                <Button size="small" variant={mode === MODE_FIXO ? 'contained' : 'outlined'} onClick={() => setMode(MODE_FIXO)} sx={{ textTransform: 'none' }}>
                    Valor fixo
                </Button>
                <Button size="small" variant={mode === MODE_A_PARTIR_DE ? 'contained' : 'outlined'} onClick={() => setMode(MODE_A_PARTIR_DE)} sx={{ textTransform: 'none' }}>
                    A partir de
                </Button>
                <Tooltip title="Não mostra nenhum valor - o cliente precisa perguntar">
                    <Button size="small" variant={mode === MODE_SOB_CONSULTA ? 'contained' : 'outlined'} onClick={() => setMode(MODE_SOB_CONSULTA)} sx={{ textTransform: 'none' }}>
                        Sob consulta
                    </Button>
                </Tooltip>
            </Stack>

            {mode !== MODE_SOB_CONSULTA && (
                <TextField
                    fullWidth
                    label={mode === MODE_A_PARTIR_DE ? 'A partir de' : 'Valor'}
                    value={display}
                    onChange={handleValueChange}
                    InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                />
            )}
        </Stack>
    );
};

export default ImovelPriceInput;
